module.exports = __webpack_public_path__ + "img/IMG_2614_T_FoamcoreMatted.fedb9538.jpg";